import comm from '@utils/comm';
import { error_custom_prefix, error_retry_prefix } from '@utils/comm';
import testingApi from '@utils/testingGUIAPI';

import {PARAM_CHANGE} from '@store/actions/index';
import BLOCKS from '@store/blocks';

import appConfig from '@constants/app.json';

export function loadData(store) {
  comm.loadData((err) => {
    OPEN_POPUP(store, error_custom_prefix + err);
  }, () => {
    testingApi.setDataStore(comm.dataStore);

    PARAM_CHANGE(store, BLOCKS.USER_INFO.BALANCE, comm.dataStore.balance);
    PARAM_CHANGE(store, BLOCKS.USER_INFO.USERNAME, comm.dataStore.username);
    PARAM_CHANGE(store, BLOCKS.APP.LOADED, true);
  }, type => OPEN_POPUP(store, error_retry_prefix + type));
}

export function OPEN_POPUP(store, type) {
  PARAM_CHANGE(store, BLOCKS.APP.POPUP, type);
}

export function closePopup(store) {
  PARAM_CHANGE(store, BLOCKS.APP.POPUP, '');
}

export function SIZE_CHANGE(store, containerBox) {
  const containerWidth = containerBox.width;
  const containerHeight = containerBox.height;
  let scale = 1;

  if ((containerWidth / containerHeight) >= (appConfig.width / appConfig.height)) {
    scale = appConfig.height / containerHeight;
  } else {
    scale = appConfig.width / containerWidth;
  }

  PARAM_CHANGE(store, BLOCKS.APP.SCALE, scale);
}